import { useMemo } from 'react';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { FileIcon } from 'foundations-assets';
import { FOLDER_PROPERTIES, UNFILED_ASSETS_ID } from 'framework-listing-lib/internal/Folders/constants/folders';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import useUnfiledAssetTotal from 'framework-listing-lib/internal/Folders/hooks/useUnfiledAssetTotal';
import { StyledCountWrapper, StyledFolderNavItemWrapper } from 'framework-listing-lib/internal/Folders/utils/styled';
import NavItemTooltip from './NavItemTooltip';
import { Spacer } from 'foundations-components/components/Spacer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnfiledAssetsNavItem = ({
  selectedAssetCount,
  folder,
  isSelected,
  onClick,
  openFoldersMap,
  selectedAssetFolderId
}) => {
  const unfiledAssetTotal = useUnfiledAssetTotal();
  const open = useMemo(() => {
    return UNFILED_ASSETS_ID in openFoldersMap && openFoldersMap[UNFILED_ASSETS_ID].includes(folder.objectId);
  }, [folder.objectId, openFoldersMap]);
  const folderName = getPropertyValue(folder, FOLDER_PROPERTIES.name);
  const shouldDisableText = useMemo(() => {
    if (!selectedAssetFolderId) {
      return false;
    }
    return UNFILED_ASSETS_ID === parseInt(selectedAssetFolderId, 10);
  }, [selectedAssetFolderId]);
  return /*#__PURE__*/_jsxs(StyledFolderNavItemWrapper, {
    isSelected: isSelected,
    "data-folder-id": UNFILED_ASSETS_ID,
    "data-parent-folder-id": UNFILED_ASSETS_ID,
    "data-test-id": "crm-listing-folder-nav-unfiled",
    "data-open": open,
    onClick: () => onClick(folder),
    children: [/*#__PURE__*/_jsx(FileIcon, {
      color: shouldDisableText ? 'icon-core-subtle' : 'fill-accent-blue-default',
      size: "400"
    }), /*#__PURE__*/_jsx(Spacer, {
      space: "0",
      display: "inline-block",
      marginInlineEnd: "250"
    }), /*#__PURE__*/_jsx(UIFlex, {
      align: "center",
      children: /*#__PURE__*/_jsx(NavItemTooltip, {
        selectedAssetCount: selectedAssetCount,
        disabled: !shouldDisableText,
        children: /*#__PURE__*/_jsxs(UITruncateString, {
          children: [folderName, /*#__PURE__*/_jsxs(StyledCountWrapper, {
            children: ["(", unfiledAssetTotal, ")"]
          })]
        })
      })
    })]
  });
};
export default UnfiledAssetsNavItem;